<template>
    <modal v-on:closemodal="cancel" @close="cancel" dialog="modal-lg" class="dark-top" :footer="true">
        <div slot="title">
            <h2>Calendar Settings</h2>
        </div>

        <div slot="body">
            <div v-if="!getSlimFilters || getIsLoadingEvents" class="text-center p-4">
                <loader></loader>
            </div>

            <div v-else class="container">

                <!-- Title -->
                <div class="pt-4 fs-large dark bold">
                    Select the information you want to be visible in the events.
                </div>

                <!-- options -->
                <div class="row pt-4 pb-2">
                    <div class="col-sm-6 d-flex align-items-center py-2">
                        <checkbox v-model="getCurrentAccountType.isCalendarToShowStartEndTime"></checkbox>
                        Show Event Date (Start/End)
                    </div>

                    <div class="col-sm-6 d-flex align-items-center py-2">
                        <checkbox v-model="getCurrentAccountType.isCalendarToShowProductName" ></checkbox>
                        Show Product Name
                    </div>

                    <div class="col-sm-6 d-flex align-items-center py-2">
                        <checkbox v-model="getCurrentAccountType.isCalendarToShowEventResourcesName" ></checkbox>
                        Show Resource
                    </div>

                    <div class="col-sm-6 d-flex align-items-center py-2">
                        <checkbox v-model="getCurrentAccountType.isCalendarToShowQuantityAvailable" ></checkbox>
                        Show Availability
                    </div>

                    <div class="col-sm-6 d-flex align-items-center py-2">
                        <checkbox v-model="getCurrentAccountType.isCalendarToShowOccupancy" ></checkbox>
                        Show Occupancy
                    </div>

                    <div class="col-sm-6 d-flex align-items-center py-2">
                        <div class="w-100 mt-2">
                            <label>Default Calendar View</label>
                            <vSelect :options="calendarViewOptions" v-model="defaultCalendarView" :reduce="name => name.value" label="name" @input="changeDefaultCalendarView($event)"></vSelect>
                        </div>
                    </div>
                </div>
                <div class="row pb-4">
                    <div class="col-sm-6 d-flex align-items-center py-2">
                        <div class="w-100 mt-2">
                            <label>Show Sales Channels Availability Indicator</label>
                            <vSelect placeholder="Select a Sale Channel" label="brandName" :options="salesChannel" v-model="selectedSalesChannelToShowInIndicatorID" :reduce="brandName => brandName.id" @input="setSelectedSalesChannelToShowInIndicator"></vSelect>
                        </div>
                    </div>
                </div>
            </div>

        </div>

        <div slot="footer" class="d-flex flex-all">
            <button type="button" class="btn cancel wider" @click="cancel">Cancel</button>
            <button type="button" class="btn ok wider" @click="save" :disabled="getUpdatingSupplierSettings || getIsLoadingEvents">Save</button>
        </div>
    </modal>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'

    import Modal from './Modal'
    import Loader from '@/tools/loaders/loader1'
    import extendedVSelect from '@/extends/vue-select'
    import $ from 'jquery'

    export default {
        data() {
            return {
                showStartEndTime: false,
                clonedCurrentAccountType: null,
				calendarViewOptions: [
					{
						name: 'Day',
						value: 0
					},
					{
						name: 'Week',
						value: 1
					},
					{
						name: 'Month',
						value: 2
					}
				],
				defaultCalendarView: {
					name: 'Day',
					value: 0
				}
            }
        },
        created() {
            this.clonedCurrentAccountType = Object.assign({}, this.getCurrentAccountType)

            this.selectedSalesChannelToShowInIndicatorID = this.salesChannel.find(c => c.id == this.getCurrentAccountType.selectedSalesChannelToShowInIndicatorID)
			this.defaultCalendarView = this.calendarViewOptions.find(co => co.value === this.getCurrentAccountType.defaultCalendarView)
        },
        computed: {
            ...mapGetters([
                'getSlimFilters',
                'getIsLoadingEvents',
                'getCurrentAccountType',
                'getStoredEvents',
                'getSalesChannels',
				'getUserDetails',
                'getUpdatingSupplierSettings',
                'getDateInterval',
                'account'
            ]),
            salesChannel() {
                let output = this.getSalesChannels.filter( c => c.isImmutable );
                output.unshift({brandName: 'None Selected'});
                
                return output;
            },
        },
        methods: {
            ...mapActions([
                'closeModal',
                'updateSupplierSettings',
                'downloadEvents'
            ]),
			changeDefaultCalendarView(event) {
				this.defaultCalendarView = event
				this.getCurrentAccountType.defaultCalendarView = event.value
				this.getUserDetails.userAccountTypeDefault.defaultCalendarView = event.value
			},
            setSelectedSalesChannelToShowInIndicator(selectedChannel) {
                this.getCurrentAccountType.selectedSalesChannelToShowInIndicatorID = selectedChannel.id
            },
            renderFilters(source, reset) {
                let cal = $('#calendar');

                cal.fullCalendar('removeEvents');
                cal.fullCalendar('addEventSource', source);

                this.$forceUpdate()
            },
            cancel() {
                // Restore changes
                this.getCurrentAccountType.isCalendarToShowStartEndTime = this.clonedCurrentAccountType.isCalendarToShowStartEndTime
                this.getCurrentAccountType.isCalendarToShowProductName = this.clonedCurrentAccountType.isCalendarToShowProductName
                this.getCurrentAccountType.isCalendarToShowEventResourcesName = this.clonedCurrentAccountType.isCalendarToShowEventResourcesName
                this.getCurrentAccountType.isCalendarToShowQuantityAvailable = this.clonedCurrentAccountType.isCalendarToShowQuantityAvailable
                this.getCurrentAccountType.isCalendarToShowOccupancy = this.clonedCurrentAccountType.isCalendarToShowOccupancy
                this.setSelectedSalesChannelToShowInIndicator(this.salesChannel.find(c => c.id == this.clonedCurrentAccountType.selectedSalesChannelToShowInIndicatorID))
				this.getCurrentAccountType.defaultCalendarView = this.clonedCurrentAccountType.defaultCalendarView

                var filtered = this.getStoredEvents;
                this.renderFilters(filtered, false)

                this.closeModal();
            },
            save() {
                // Update settings to backend
                this.updateSupplierSettings(this.getCurrentAccountType).then(()=>{
                    var filtered = this.getStoredEvents;
                    this.renderFilters(filtered, false)
                    this.updateCalendar();
                    this.closeModal();
                })
            },
            updateCalendar() {
                const fromDate = moment(this.getDateInterval.startDate).format("YYYY-MM-DD");
                const toDate = moment(this.getDateInterval.endDate).add(1, "day").format("YYYY-MM-DD");

                this.downloadEvents({
                    supplierId: this.account.supplierId,
                    dateFrom: fromDate,
                    dateTo: toDate,
                }).then(() => {
                    const calendar = $("#calendar");
                    calendar.fullCalendar("removeEvents");
                    calendar.fullCalendar("addEventSource", this.getStoredEvents);
                });
            }
        },
        components: {
            vSelect: extendedVSelect,
            Modal,
            Loader,
        }
    }
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// calendarSettings.vue?00d35e80